import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { TranslatePlural } from '@change-corgi/core-react/i18n';

import { useProfileCard } from '../../hooks/useProfileCard';

export const DmStats: React.FC = () => {
	const {
		data: { petitionsCount, displayName, responsesCount },
	} = useProfileCard();

	const bothSectionsDisplayed = petitionsCount > 1 && responsesCount > 0;

	if (responsesCount === 0) return null;

	return (
		<div data-testid="dm-stats" className="text-content-primary grid grid-cols-1 gap-6 md:grid-cols-4">
			{petitionsCount > 1 && (
				<div className="col-span-1" data-testid="dm-profile-petitions-count">
					<Text as="h2" variant="heading">
						{petitionsCount}
					</Text>
					<Text as="p" variant="body">
						<TranslatePlural
							value="corgi.decision_maker_profile.profile_section.stats.petition_stat"
							count={petitionsCount}
							replacements={{ count: petitionsCount, displayName }}
						/>
					</Text>
				</div>
			)}

			<div
				className={cn('col-span-1', {
					'border-surface-accent-disabled md:border-l md:pl-8': bothSectionsDisplayed,
				})}
				data-testid="dm-profile-responses-count"
			>
				<Text as="h2" variant="heading">
					{responsesCount}
				</Text>
				<Text as="p" variant="body">
					<TranslatePlural
						value="corgi.decision_maker_profile.profile_section.stats.response_stat"
						count={responsesCount}
						replacements={{ count: responsesCount, displayName }}
					/>
				</Text>
			</div>
		</div>
	);
};
